import React, { useRef } from "react";
import { BsPrinterFill } from "react-icons/bs";
import Swal from "sweetalert2";
import axios from "axios";
import "../../ReviewComponents/ABMOfDocuments/ABMOfDocuments.css";

const PrintButton = ({ id }) => {
    const downloadLinkRef = useRef(null);

    const handlePrint = async (e) => {
        e.preventDefault();
        try {
            // Realiza una solicitud GET al servidor para obtener el archivo y su tipo
            const response = await axios.get(
                `${process.env.REACT_APP_ABM_OF_DOCUMENT_GET}?id=${id}`,
                { responseType: "arraybuffer" }
            );

            // Verifica que la respuesta sea exitosa (código de estado 200)
            if (response.status === 200) {
                // Obtiene el tipo de archivo del encabezado de respuesta
                let contentType = response.headers["content-type"];

                // Elimina cualquier parte adicional después del primer punto y coma (;)
                contentType = contentType.split(";")[0];

                // Crea un blob con los datos del archivo
                const blob = new Blob([response.data], { type: contentType });

                // Crea un objeto URL para el blob
                const fileUrl = window.URL.createObjectURL(blob);

                // Abre una ventana con la vista previa del archivo
                const printWindow = window.open(fileUrl, "_blank");

                // Espera a que la vista previa del archivo se cargue antes de imprimir
                printWindow.onload = () => {
                    printWindow.print();
                    printWindow.onafterprint = () => {
                        // Cierra la ventana después de la impresión
                        printWindow.close();
                    };
                };
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Error al obtener el archivo del servidor",
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Parece que hubo un error al tratar de enviar el documento.",
            });
        }
    };

    return (
        <button
            className="button_abm"
            type="button"
            onClick={(e) => handlePrint(e)}
            ref={downloadLinkRef}
        >
            <i className="fa fa-refresh"></i>
            <BsPrinterFill className="icon-list" />
        </button>
    );
};

export default PrintButton;